import { Metadata } from '../types';

import {
  RawShareListUser, ShareListUser,
} from './types';

export const toShareListUsers = ({ data, metadata }: {
  data: RawShareListUser[],
  metadata: Metadata
}): {data: ShareListUser[], metadata: Metadata} => ({
  data: data.map((user) => ({
    ...user,
    id: user.value,
  })),
  metadata: {
    ...metadata,
    id: {
      hide: true,
      label: 'ID',
      type: 'text',
      editable: false,
    },
    name: {
      hide: true,
      label: 'Name',
      type: 'text',
      editable: false,
    },
  },
});
